import React, { useEffect } from "react";

import { SAlert, SCol, SRow } from "@avalara/skylab-sdk/react";
import FromToComponent from "../../../components/FromToComponent";
import { MappingContext } from "../../../context/mappingDataContext";

import "./styles.scss";
import PageHeader from "../../../components/PageHeader/PageHeader";

const FieldsMapping = () => {
  const { fromTo, headers } = MappingContext();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <PageHeader headerTitle="Required and optional columns" />
      <SAlert id="alertId" status="info" noDismiss>
        <div>We need these settings to process your transactions.</div>
      </SAlert>

      <SRow className="hide-on-sm">
        <SCol span="6" className="pad-bottom-none">
          <h2>Avalara - Destination Fields</h2>
        </SCol>
        <SCol span="1" className="pad-bottom-none"></SCol>
        <SCol span="5" className="pad-bottom-none">
          <h2>Imported File - Source Fields</h2>
        </SCol>
      </SRow>

      <hr className="margin-top-none" />

      {fromTo.map((item, index) => {
        return (
          <div key={item.id}>
            <FromToComponent item={item} data={headers} />
            {index < fromTo.length - 1 && <hr />}
          </div>
        );
      })}
    </>
  );
};

export default FieldsMapping;
